/**
 * Standard Voluum Config Tab — entry point
 * For Media Devoted | Created By Ciro Autiero
 *
 * By default renders the typed Standard tab (v2). Only when
 * `VOLUUM_STANDARD_V2` is off (see `feature-flags.ts`) does this fall back to
 * the legacy JSON editor for emergencies.
 */

import { FC } from 'react';

import { VOLUUM_STANDARD_V2 } from '../feature-flags';
import StandardConfigBasicFields from './standard/StandardConfigBasicFields';
import StandardConfigJsonEditor from './standard/StandardConfigJsonEditor';
import { StandardConfigTabV2 } from './standard/v2';

export interface StandardConfigTabProps {
  flowId: string;
  killSwitch: boolean;
  standardJson: Record<string, unknown>;
  onChange: (next: Record<string, unknown>) => void;
  /** When false, Standard v2 does not register Apply/Discard in the drawer footer. */
  standardTabActive?: boolean;
}

const StandardConfigTab: FC<StandardConfigTabProps> = ({
  flowId,
  killSwitch,
  standardJson,
  onChange,
  standardTabActive = true,
}) => {
  if (VOLUUM_STANDARD_V2) {
    return (
      <StandardConfigTabV2
        flowId={flowId}
        killSwitch={killSwitch}
        standardTabActive={standardTabActive}
      />
    );
  }
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
      <div className="min-h-0 flex-1 space-y-4 overflow-y-auto pr-1">
        <StandardConfigBasicFields standardJson={standardJson} onChange={onChange} />
        <StandardConfigJsonEditor standardJson={standardJson} onChange={onChange} />
      </div>
    </div>
  );
};

export default StandardConfigTab;
